/**
 *
 * @module component/helpers
 * @author Greg Babula [greg.babula@mlb.com]
 * @see ./example/simple/component/helpers
 *
 */

/**
 *
 * @name helpers
 * @desc handlebars helpers to be registered
 *
 */
const helpers = {

};

export default helpers;
